
        import '/home/builduser/work/c1dd1064fea009a6/santa-editor/packages/appManager/AppManagerPanel/AppManagerPanel.scss.css.virtualfile';
        module.exports = {"content":"_content_1bpb0_7","loaderWrapper":"_loaderWrapper_1bpb0_12"};